if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');

      this.disableRebuySmartCartProductFormRedirect();
    }

    onSubmitHandler(evt) {

      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      if (this.cartNotification && typeof this.cartNotification.setActiveElement === 'function') {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      const formData = new FormData(this.form);
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.cartNotification && typeof this.cartNotification.getSectionsToRender === 'function') {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      }
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (this.cartNotification && typeof this.cartNotification.renderContents === 'function') {
            this.cartNotification.renderContents(response);
          }
          this.upgradeToSubscription(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    async upgradeToSubscription(response) {
      if (response.selling_plan_allocation) return
      const upsellJson = this.querySelector('script.subscription-upsell-data')
      if (!upsellJson) return
      const upsellData = JSON.parse(upsellJson.textContent)
      const productJson = await fetch(`/products/${response.handle}.js`)
        .then((response) => response.json())
      const variant = productJson.variants.find((variant) => variant.id === response.id)

      const availableSellingPlanGroups = productJson.selling_plan_groups.filter((selling_plan_group) => selling_plan_group.name !== 'Dynamic Box Subscription')
      const availableSellingPlanGroupsIds = availableSellingPlanGroups.map((selling_plan_group) => selling_plan_group.id)
      const sellingPlanAllocation = variant.selling_plan_allocations.find((selling_plan_allocation) => availableSellingPlanGroupsIds.includes(selling_plan_allocation.selling_plan_group_id))
      if (!sellingPlanAllocation) return
      const sellingPlan = sellingPlanAllocation.selling_plan_id

      window.setTimeout(() => {
        // show the modal
        const existingUpgradeToSubscriptionModal = document.querySelector('#PopupModal-UpgradeToSubscription')
        if (existingUpgradeToSubscriptionModal) {
          existingUpgradeToSubscriptionModal.remove()
        }
        const modalMarkup = `
          <modal-dialog open id="PopupModal-UpgradeToSubscription" class="product-popup-modal">
            <style>
              .subscription-popup-modal__content {
                background-image: url(${upsellData.mobile});
              }
              @media screen and (min-width: 750px) {
                .subscription-popup-modal__content {
                  background-image: url(${upsellData.desktop});
                } 
              }
            </style>
            <div role="dialog" aria-label="${upsellData.cta}" aria-modal="true" class="subscription-popup-modal__content" tabindex="-1">
              <div class="subscription-popup-modal__actions">
                <button class="subscription-popup-modal__upgrade" style="background-color: ${upsellData.cta_background_color}; color: ${upsellData.cta_color}">${upsellData.cta}</button>
                <button id="ModalClose-UpgradeToSubscription" type="button" class="subscription-popup-modal__toggle" aria-label="{{ 'accessibility.close' | t }}" style="color: ${upsellData.dismiss_color}">${upsellData.dismiss}</button>
              </div>
            </div>
          </modal-dialog>
        `;
        document.body.insertAdjacentHTML('beforeend', modalMarkup);
        const upgradeToSubscriptionModal = document.querySelector('#PopupModal-UpgradeToSubscription')
        window.setTimeout(() => {
          upgradeToSubscriptionModal.classList.add('fade-in')
        }, 20)
        const upgradeToSubscriptionCta = upgradeToSubscriptionModal.querySelector('.subscription-popup-modal__upgrade')
        upgradeToSubscriptionCta.addEventListener('click', () => {
          // change the line item to subscription
          upgradeToSubscriptionCta.classList.add('loading')
          window.setTimeout(async () => {
            const cartLineKey = response.key
            const cartJson = await fetch('/cart.json').then((response) => response.json())
            const lineIndex = cartJson.items.findIndex((cartLine) => cartLine.key === cartLineKey)
            await fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                'line': lineIndex + 1,
                'selling_plan': sellingPlan
              })
            })
            upgradeToSubscriptionModal.hide()
          }, 250)
        })
      }, 500)
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    disableRebuySmartCartProductFormRedirect() {
      const RebuySmartCartProductFormRedirect = window.Rebuy?.SmartCart?.settings?.product_form_redirect
      if (RebuySmartCartProductFormRedirect) {
        window.Rebuy.SmartCart.settings.product_form_redirect = 'disabled'
      } else {
        document.addEventListener('rebuy:smartcart.ready', () => {
          const RebuySmartCartProductFormRedirect = window.Rebuy?.SmartCart?.settings?.product_form_redirect
          if (RebuySmartCartProductFormRedirect) {
            window.Rebuy.SmartCart.settings.product_form_redirect = 'disabled'
          }
        });
      }      
    }

  });
}
